<script>

export default {

  name: 'Message',

  components: {},

  mixins: [],

  props: {
    content: {
      required: true,
      type: String,
      default: ''
    },
    timestamp: {
      required: true,
      type: String,
      default: ''
    },
    username: {
      required: false,
      type: String,
    },
    local: {
      required: true,
      type: Boolean,
    },
  },

  data() {
    return {
      hyperLinkRegex: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
    }
  },

  computed: {
    linkifiedContent() {
      return this.content.replace(
          this.hyperLinkRegex,
          (match)=>`<a href="${match}" rel="noreferrer" target="_blank" class="underline font-bold">${match}</a>`);
    }
  },
};

</script>


<template>

  <div :class="!local ? `col-start-6 col-end-13 p-3 rounded-lg` : `col-start-1 col-end-8 p-3 rounded-lg` ">
    <div :class="!local ? `flex items-center justify-start flex-row-reverse` : `flex flex-row items-center`">
      <div class="flex items-center justify-center h-10 w-10 rounded-full bg-indigo-500 flex-shrink-0">
        {{ username ? username.substr(0,1)  : ':)' }}
      </div>
      <div class="relative mx-3 text-sm bg-indigo-100 py-2 px-4 shadow-sm rounded-md">
        <div v-html="linkifiedContent"></div>
<!--        <div>{{ content }}</div>-->
      </div>
      <div class="text-xs mr-2 text-gray-500">
        {{ timestamp }}
      </div>
    </div>
  </div>

</template>